<ng-container [formGroup]="formStopFilter">
    <label class="container" *ngFor="let stop of orderedStopQuantities; let i = index">
        <input type="checkbox" (click)="sendFilterOption(stop, i)" [value]="stop" [formControl]="stopFilterArray.at(i)">
        <span class="checkmark"></span>
        {{ stop === 0 ? 'Sem paradas' : stop + ' ' + (stop === 1 ? 'parada' : 'paradas') }}
    </label>
</ng-container>

